<template>
<div v-if="isFM">
  <b-nav small class="my-0">
    <b-nav-item class="mute" target="_blank" href="https://www.fmmodule.nl/ideeen/">{{$t('fmweb.linkIdee')}}</b-nav-item>
    <b-nav-item target="_blank" href="https://www.fmmodule.nl/wiki/help-functie-fm-module/">{{$t('fmweb.linkHelpFunctie')}}</b-nav-item>
  </b-nav>
  <hr class="my-0">
</div>
</template>

<script>
import { productInfo } from '@/mixins/productInfo'

export default {
    mixins: [productInfo],	
    name: "FooterBar",
	computed: {
		isFM() {
			return this.isFMModule()
		}
	}
}
</script>

<style>
ul a.nav-link {
	padding-top: 0;
}

ul li:first-child a.nav-link {
	padding-left: 0;
}
</style>